import React from 'react';
import { Text, View } from 'react-native';

import { adminTableMemberGridStyles } from './adminTableMemberGridStyles';

export interface AdminTableInlineMessageRowProps {
  message: string;
  testID?: string;
}

export const AdminTableInlineMessageRow: React.FC<
  AdminTableInlineMessageRowProps
> = ({ message, testID }) => (
  <View style={adminTableMemberGridStyles.inlineMessageRow} testID={testID}>
    <Text style={adminTableMemberGridStyles.inlineMessageText}>{message}</Text>
  </View>
);
